<template lang="pug">
  div.location-tariff
    div.top-block
      e-form(
      :formValidator="formValidator"
      formClass=" "
      :enablePerfectScrollbar="false"
      )
        div.body
          div.col
            e-form-subtitle(text="Настройки")
            e-form-group(
            name="capacity"
            label="S - средняя производительность принятого в расчетах транспортного средства по вывозу"
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
              name="tkoObjectName"
              realName="tko_object_id"
              inputType="suggestion"
              label="Объект размещения"
              :suggestionEndpoint="suggestionEndpoint"
              :transformSuggestions="transformSuggestions"
              @selectItem="selectItem"
              :suggestDelay="0"
              :minSuggestLen="2"
              :useInnerSearch="false"
              :required="true"
              :model="fields"
              tabView="tab1"
            )

            e-form-group(
            name="zero_run"
            label="L0 - средний нулевой пробег, приходящегося на 1 рейс"
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
            name="loading_time"
            label="Н погр-разгр - нормативная продолжительность погрузки-разгрузки, включая маневрирование, час"
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
            name="fuel_price"
            label="Ц - планируемая среднерыночная цена за единицу топлива"
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
            name="transport_price"
            label="Стр - среднерыночная цена транспорта"
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
            name="transport_work"
            label="Гч - годовое число часов работы транспортного средства "
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
            name="amortization_rate"
            label="Н - норма амиортизационных отчислений %"
            :model="fields"
            tabView="tab1"
            validationRule="double"
            )

            e-form-group(
            name="fuel_consumption"
            label="Q - норма расхода топлива"
            :model="fields"
            tabView="tab1"
            )

          div.col
            e-form-subtitle(text="Параметры для расчета тарифа")

            e-form-group(
            name="geo_object"
            label="Муниципальное образование"
            :model="fields"
            tabView="tab1"
            )

            e-form-group(
            name="population"
            label="Население"
            :model="fields"
            tabView="tab1"
            )

            e-form-group(
            name="tariff_area"
            label="Площадь"
            :model="fields"
            tabView="tab1"
            )


            e-form-group(
            name="containers_count"
            label="Общее количество контейнерных площадок"
            :model="fields"
            tabView="tab1"
            )

            e-form-group(
            name="container_volume"
            label="Средний объём контейнерной площадки"
            :model="fields"
            tabView="tab1"
            :required="true"
            validationRule="double"
            )

            e-form-group(
            name="transport_distance"
            label="Среднее расстояние транспортировки ТБО"
            :model="fields"
            tabView="tab1"
            :required="true"
            validationRule="double"
            )

            e-form-group(
            name="msn_distance"
            label="Среднее расстояние между местами сбора"
            :model="fields"
            tabView="tab1"
            :required="true"
            validationRule="double"
            )


            e-form-group(
            name="formed"
            label="Количество образуемых отходов куб.м./год"
            :model="fields"
            tabView="tab1"
            )

            e-form-group(
            name="tariff_burial"
            label="Тариф на захоронение"
            :model="fields"
            tabView="tab1"
            :required="true"
            validationRule="double"
            )

            e-form-group(
            name="tariff_processing"
            label="Тариф на обработку"
            :model="fields"
            tabView="tab1"
            :required="true"
            validationRule="double"
            )


        div.body
          div.col
            e-form-subtitle(text="Итоги расчета")
            e-form-group(
            name="L_tr"
            label="L тр"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="L_ost"
            label="L ост метры"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="M"
            label="М ост метры"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="N_sred"
            label="N сред"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="O"
            label="O"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="L_sb"
            label="L сб км"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )

          div.col
            e-form-subtitle(text="").is-hidden
            e-form-group(
            name="N_e"
            label="Не"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_zp"
            label="C зп"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_otch"
            label="Сотч"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_va"
            label="Сva"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="Q"
            label="Q"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )

          div.col
            e-form-subtitle(text="").is-hidden
            e-form-group(
            name="S_t"
            label="С т"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_m"
            label="C м"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_r"
            label="C р"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_oer"
            label="С оэр"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="S_pr"
            label="С пр"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )
            e-form-group(
            name="transport_tariff"
            label="Тариф на транспортировку 1 куб м тко"
            :model="fields"
            tabView="tab1"
            :disabled="true"
            )


</template>

<script>
  import {calculation, tko} from "../../../api/api-endpoints";
  import FormValidator from '../../../components/form/form-validator'

  const TARIFF_ID = 'tariff_id'

  export default {
    name: "location-tariff",
    props: {
      model: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      fields: {
        tko_object_id: ''
      }
    }),
    created () {
      this.formValidator = new FormValidator(this)
      this.subs = this.$emitter.listen('locationTariff.calc', this.calc)
      this.fetchAll()
    },
    destroyed () {
      this.subs && this.subs.unsubscribe()
    },
    methods: {
      suggestionEndpoint (ctx, q) {
        return tko.objects({query: {q, 'per-page': 50}})
      },
      selectItem ($event) {
        if ($event && $event.id) {
          let copy = JSON.parse(JSON.stringify($event))
          this.fields.tko_object_id = copy.id
          this.fields.tkoObjectName = this.$options.filters.stripHtml(
            copy.name
          )
        } else {
          this.fields.tko_object_id = ''
          this.fields.tkoObjectName = ''
        }
      },
      transformSuggestions (ctx, data) {
        return data.data
      },
      async calc ({unFreezeFrom = () => ''} = {}) {
        let {hasError} = this.formValidator.validate(this)
        if (!hasError) {
          if(!this.model[TARIFF_ID]) {
            this.$e.errorBox('Нет идентификатора тарифа', {
              text: `Требуется ${TARIFF_ID}`
            })
            unFreezeFrom()
            return
          }

          try {
            const {data} = await this.$store.dispatch('updateModel', {
              url: calculation.locationTariffOneAtuUpdate(this.model[TARIFF_ID]),
              data: this.fields
            })
            this.mapModelToFields(data)
            this.$e.successBox('Рассчет завершен')
            this.$emit('calcSuccess')

            // scroll form to bottom
            this.$emitter.emit('atu.objectUpdate.scroll', {
              action: 'scroll',
              coords: {
                y: 999999
              }
            })
          } catch (erResponse) {
            let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this)
            if (notFoundedErrorFieldsText) {
              this.$e.errorBox(
                'Некорректно заполнены поля',
                {text: notFoundedErrorFieldsText}
              )
            }
          }
        }

        unFreezeFrom()
      },
      async fetchAll () {
        try {
          this.$bar.start()

          if (this.model[TARIFF_ID]) {
            const {data} = await this.$store.dispatch('updateUrlEndpoint', {
              endpoint: calculation.locationTariffOneAtu(this.model[TARIFF_ID]),
              params: {
                disableGlobalError: true
              }
            })

            this.mapModelToFields(data)
          }
        } catch (e) {
          console.error(e)
          this.$e.errorBox('Ошибка при загрузке тарифа')
        } finally {
          this.$bar.finish()
        }
      },
      mapModelToFields (data) {
        this.fields = Object.assign({}, data)

        if (this.fields.tkoObject) {
          this.fields.tkoObjectName = this.fields.tkoObject.name
        }
      }
    }
  }
</script>
